/**
 * Utility functions for assignment modal operations
 */

export const deduplicateItems = <T>(
  items: T[],
  getId: (item: T) => number
): T[] => {
  return items.filter(
    (item, index, array) =>
      array.findIndex((i) => getId(i) === getId(item)) === index
  );
};

export const addUniqueItems = <T>(
  existingItems: T[],
  newItems: T[],
  getId: (item: T) => number
): T[] => {
  const existingIds = new Set(existingItems.map((item) => getId(item)));
  const uniqueNewItems = newItems.filter(
    (item) => !existingIds.has(getId(item))
  );
  return [...existingItems, ...uniqueNewItems];
};
